import { HttpErrorResponse } from '@angular/common/http';
import {
    GetNotesTypesNamesAndIdsDTO,
    GetTranslationsDto,
    INotesOfAnnualReportDTO,
    INotesTemplateDTO,
    INotesTemplateEntityDTO,
    INotesTypeEntityDTO,
    UpdateNotesTypeDto,
    UpdateTranslationsDto,
} from '@modeso/types__aumico-lib-notes-be';
import { Observable } from 'rxjs';
import { ILegalFormAndAccountBasisCombinationCheck } from '../interfaces/ILegalFormAndAccountBasisCombinationCheck.interface';
import { INameExistenceFiltration } from '../interfaces/INameExistenceFiltration.interface';
import { INotesTemplateByLegalFormAndAccountBasisRequest } from '../interfaces/requests/INotesTemplateByLegalFormAndAccountBasisRequest.interface';

export interface INotesProvider {
    dispatchNotesTemplates(): void;
    getNotesTemplates$(): Observable<INotesTemplateDTO[]>;
    selectActiveNotesTemplate(id: string): void;
    getActiveNotesTemplate$(): Observable<INotesTemplateDTO>;
    createNotesTemplate(notesTemplate: INotesTemplateEntityDTO): void;
    editNotesTemplate(notesTemplate: INotesTemplateEntityDTO): void;
    checkNotesTemplateNameExistence$(filtration: INameExistenceFiltration): Observable<boolean>;
    checkLegalFormAndAccountBasisCombination$(
        combination: ILegalFormAndAccountBasisCombinationCheck,
    ): Observable<boolean>;
    getNotesTemplateError$(): Observable<HttpErrorResponse>;
    dispatchNotesOfAnnualReport(combination: INotesTemplateByLegalFormAndAccountBasisRequest): void;
    getNotesOfAnnualReport$(): Observable<INotesOfAnnualReportDTO>;
    resetNotes(): void;

    dispatchNotesTypes(): void;
    getNotesTypes$(): Observable<INotesTypeEntityDTO[]>;
    getNotesTypesNamesAndIds$(): Observable<GetNotesTypesNamesAndIdsDTO[]>;
    dispatchGetAllNotesTypesNamesAndIds(): void;
    selectActiveNotesType(id: string): void;
    getActiveNotesType$(): Observable<INotesTypeEntityDTO>;
    createNotesType(notesType: INotesTypeEntityDTO): void;
    editNotesType(notesType: UpdateNotesTypeDto): void;
    checkNotesTypeNameExistence$(filtration: INameExistenceFiltration): Observable<boolean>;
    getNotesTypeError$(): Observable<HttpErrorResponse>;

    getTranslations$(): Observable<GetTranslationsDto>;
    dispatchGetTranslations(locales: string[], untranslatedOnly: boolean): void;
    dispatchUpdateTranslations(translations: UpdateTranslationsDto): void;
}
